import { BasketDiscountType, DiscountValue } from 'apis/restaurant-api/merchant-admin/campaigns/types';

export const getBasketDiscountType = (discountValue?: DiscountValue): BasketDiscountType =>
  typeof discountValue?.percentage === 'number' ? BasketDiscountType.PERCENTAGE : BasketDiscountType.AMOUNT;
